import { render, staticRenderFns } from "./AdditionDrawerForm.vue?vue&type=template&id=0a265ffa&"
import script from "./AdditionDrawerForm.vue?vue&type=script&lang=ts&"
export * from "./AdditionDrawerForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports